import { memo } from 'react';
import * as THREE from 'three';
import { CLASSICAL } from '../materials';

const G = {
  fenceRail: new THREE.BoxGeometry(1, 0.025, 0.02),
  fencePost: new THREE.CylinderGeometry(0.018, 0.018, 0.12, 5),
};

/**
 * One fence section along a tile edge: a rail of `length` with posts at both
 * ends, `height` times the usual height.
 */
export const FenceSection = memo(function FenceSection({
  x,
  z,
  yaw,
  length,
  height = 1,
}: {
  x: number;
  z: number;
  yaw: number;
  length: number;
  height?: number;
}) {
  return (
    <group position={[x, 0, z]} rotation={[0, yaw, 0]} scale={[1, height, 1]}>
      <mesh
        geometry={G.fenceRail}
        material={CLASSICAL.WOOD}
        position={[0, 0.07, 0]}
        scale={[length, 1, 1]}
      />
      <mesh
        geometry={G.fenceRail}
        material={CLASSICAL.WOOD}
        position={[0, 0.035, 0]}
        scale={[length, 1, 1]}
      />
      <mesh
        geometry={G.fencePost}
        material={CLASSICAL.DARK_WOOD}
        position={[-length / 2, 0.06, 0]}
      />
      <mesh
        geometry={G.fencePost}
        material={CLASSICAL.DARK_WOOD}
        position={[length / 2, 0.06, 0]}
      />
    </group>
  );
});
